'use client';

import Script from 'next/script';
import {set} from 'nprogress';
import {useEffect} from 'react';
import {UseFormRegister} from 'react-hook-form';

export const RECAPTCHA_SITE_KEY =
  process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || '';

declare global {
  const grecaptcha: {
    enterprise: {
      ready: (cb: () => void) => void;
      execute: (siteKey: string, options: {action: string}) => Promise<string>;
    };
  };
}
interface Props {
  action: string;
  register?: UseFormRegister<any> | undefined;
  setToken?: (token: string) => void;
}

export function RecaptchaWrapper({action, register, setToken}: Props) {
  const executeRecaptcha = () => {
    if (typeof grecaptcha !== 'undefined') {
      grecaptcha.enterprise.ready(async () => {
        try {
          const token = await grecaptcha.enterprise.execute(
            RECAPTCHA_SITE_KEY,
            {
              action,
            }
          );
          const tokenInput = document.getElementById(
            'recaptcha-token'
          ) as HTMLInputElement;
          setToken && setToken(token);
          if (tokenInput) tokenInput.value = token;
        } catch (e) {
          console.error('Recaptcha error', e);
        }
      });
    }
  };

  return (
    <>
      <Script
        src={`https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`}
        strategy="afterInteractive"
        onLoad={executeRecaptcha}
      />
      <input
        type="hidden"
        {...(register && register('recaptchaToken'))}
        name="recaptchaToken"
        id="recaptcha-token"
      />
    </>
  );
}
